import React, { useContext } from "react";
import "./ProjectDetails.css";
import { ProjectContext } from "../context/ProjectContext";

const ProjectHeader = ({ onBack }) => {
  const { projectDetails, loadingProject } = useContext(ProjectContext);

  if (loadingProject) return <p>Loading...</p>;
  if (!projectDetails) return null;

  return (
    <div className="project-header">
      <div className="container-fluid">
        {/* Back Button */}
        <button
          className="btn btn-link text-white mb-3 back-btn"
          onClick={onBack}
        >
          <i className="bi bi-arrow-left me-2"></i>
          Back to Projects
        </button>

        {/* Header Content */}
        <div className="d-flex flex-wrap align-items-center justify-content-between">
          <div>
            <h1 className="project-title mb-2">
              {projectDetails.title}
            </h1>

            <div className="project-meta">
              {/* <span>Project ID: {String(projectDetails.project_id).padStart(5, "0")}</span> */}
              <span className="dot">•</span>
              <i className="bi bi-mortarboard me-1"></i>
              <span>{projectDetails.department}</span>
            </div>
          </div>

          <span className="badge project-status">
            {projectDetails.project_status}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProjectHeader;
